import e from "../../utils/classNames.js";
import { useState as t } from "react";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
//#region src/components/pager/Pager.tsx
var i = {
	VARIANT_FULL: "full",
	VARIANT_COMPACT: "compact"
}, a = (o) => {
	let { title: s, label: c, alignRight: l = !1, variant: u = i.VARIANT_FULL, disabled: d = !1, onClick: f, className: p, ...m } = o, [h, g] = t(!1), _ = () => !d && g(!0), v = () => g(!1), y = u === a.VARIANT_COMPACT, b = e("Pager", "bg-white", "border", "display-flex justify-space-between align-items-center", h && "border-color-highlight", l && "flex-row-reverse", d && "pointer-events-none", "cursor-pointer user-select-none"), x = e("uikit-icon", d ? "text-color-light" : "text-color-darker", h && "text-color-highlight"), S = e(d ? "text-color-light" : "text-color-darker", h && "text-color-highlight");
	if (y) {
		let t = e(b, "rounded-circle", "padding-y-5 padding-x-15", "width-auto", p), i = e(x, l ? "icon-chevron-left margin-right-5" : "icon-chevron-right margin-left-5", "text-size-10");
		return /* @__PURE__ */ r("div", {
			...m,
			className: t,
			onMouseEnter: _,
			onMouseLeave: v,
			onClick: f,
			children: [/* @__PURE__ */ n("div", {
				className: `display-flex flex-1-1 flex-column ${l ? "align-items-end" : ""}`,
				children: /* @__PURE__ */ n("div", {
					className: S,
					children: s
				})
			}), /* @__PURE__ */ n("span", { className: i })]
		});
	}
	let C = e(b, "rounded", "padding-y-15 padding-x-20", "width-100pct", p), w = e(x, l ? "icon-arrow-left margin-right-10" : "icon-arrow-right margin-left-10", "text-size-200pct"), T = e(S, l && "text-right", "text-size-16 text-medium");
	return /* @__PURE__ */ r("div", {
		...m,
		className: C,
		onMouseEnter: _,
		onMouseLeave: v,
		onClick: f,
		children: [/* @__PURE__ */ r("div", {
			className: `display-flex flex-1-1 flex-column ${l ? "align-items-end" : ""}`,
			children: [/* @__PURE__ */ n("div", {
				className: "text-color-gray line-height-16",
				children: c
			}), /* @__PURE__ */ n("div", {
				className: T,
				children: s
			})]
		}), /* @__PURE__ */ n("div", {
			className: "text-size-12 display-grid place-items-center",
			children: /* @__PURE__ */ n("span", { className: w })
		})]
	});
};
a.VARIANT_FULL = i.VARIANT_FULL, a.VARIANT_COMPACT = i.VARIANT_COMPACT;
//#endregion
export { i as PagerVariant, a as default };

//# sourceMappingURL=Pager.js.map